import { NodeProps, useReactFlow, Node, Edge, getOutgoers } from 'reactflow';
import { createId } from '@paralleldrive/cuid2';
import { brandColors } from '@duke-hq/ui/theme/chakraTheme';
import { flowEditorState } from '../../flowEditorState';

export function useAddContainerButton({
  id,
  sourceHandle,
}: {
  id?: NodeProps['id'] | undefined;
  sourceHandle?: string | undefined;
}) {
  const { getNode, setNodes, setEdges, getNodes, getEdges, setCenter } = useReactFlow();

  const onClick = () => {
    if (!id) {
      console.warn('No current node id');
      return;
    }
    // we need the current node object for getting its position
    const currentNode = getNode(id);

    if (!currentNode) {
      console.warn('No current node');
      return;
    }

    const newContainerId = `container-${createId()}`;
    const newNodeId = createId();
    const parentNode = currentNode.parentNode
      ? (getNode(currentNode.parentNode) as Node)
      : currentNode;

    const newContainer: Node = {
      id: newContainerId,
      type: 'defaultContainer',
      data: { label: 'Container' },
      position: {
        x: parentNode.position.x + (parentNode === currentNode ? 500 : parentNode.width! + 200),
        y: parentNode.position.y + (parentNode === currentNode ? 0 : 200),
      },
      style: {
        background: brandColors.blackAlpha[100],
        borderColor: brandColors.blackAlpha[300],
        borderRadius: '8px',
        borderWidth: '1px',
        minHeight: '400px',
        minWidth: '600px',
      },
    };

    const newNode: Node = {
      id: newNodeId,
      data: { label: `block` },
      type: 'block',
      position: { x: 20, y: 30 },
      dragHandle: '.drag-handle',
      parentNode: newContainerId,
      extent: 'parent',
      expandParent: true,
    };

    const newEdge: Edge = {
      id: `${currentNode.id}-${newNode.id}`,
      source: currentNode.id,
      sourceHandle,
      target: newNode.id,
    };

    setNodes((nds) =>
      nds
        .map((node) => {
          if (node.id === currentNode.id) {
            node.data = {
              ...node.data,
              outgoers: getOutgoers(
                currentNode,
                [...getNodes(), newNode],
                [...getEdges(), newEdge],
              ).map((n) => n.id),
            };
          }
          return node;
        })
        .concat(newContainer)
        .concat(newNode),
    );

    setEdges((edges) => edges.concat([newEdge] as Edge[]));

    flowEditorState.markDirty();

    setCenter(newContainer.position.x + 200, newContainer.position.y + 250, {
      zoom: 1,
      duration: 800,
    });

    return newNodeId;
  };

  return onClick;
}
